<ng-container *ngIf="isDisabled; then readonly; else editing"></ng-container>

<ng-template #readonly>
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Bereich suchen"
           [ngModel]="getRegionTitle(value)"
           fullWidth
           [disabled]="true" />
    <button nbSuffix
            nbButton
            ghost
            *ngIf="value"
            (click)="goToRegion()"
            nbTooltip="Zum Bereich">
      <nb-icon icon="external-link-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>
</ng-template>

<ng-template #editing>
  <nb-form-field>
    <input nbInput
           type="text"
           #searchInput
           [ngModel]="getRegionTitle(value)"
           (ngModelChange)="filterText$.next($event);trigger$.next('reset')"
           placeholder="Bereich suchen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth/>
    <button *ngIf="value" nbSuffix nbButton ghost (click)="clear()">
      <nb-icon icon="close-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="trigger$.next('loadMore')" [threshold]="50" [throttleTime]="100">
        <nb-list-item *ngFor="let region of regions$ | async; trackBy: trackById" (click)="onSelectionChange(region)">
          <div class="user">
            <div class="name">{{ region.name }}</div>
            <div class="user-meta-info">{{ region.tenant.name }}</div>
          </div>
        </nb-list-item>
      </nb-list>
    </div>
  </ng-template>
</ng-template>
